export default __webpack_public_path__ + "static/media/google.bf9f1d76.svg";